/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MyCommunityResponse } from '../../models/my-community-response';

export interface CommunityControllerGetJoined$Params {
}

export function communityControllerGetJoined(http: HttpClient, rootUrl: string, params?: CommunityControllerGetJoined$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MyCommunityResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, communityControllerGetJoined.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MyCommunityResponse;
      }>;
    })
  );
}

communityControllerGetJoined.PATH = '/community/my';
